var render = function render(){var _vm=this,_c=_vm._self._c;return _c('job-list',{attrs:{"filters":_vm.clientJobsFilter,"filterable":true,"show-left-menu":false,"go-to-add-on-click":false},on:{"on-add":_vm.onAdd}})
}
var staticRenderFns = []

export { render, staticRenderFns }